import { Box, Button, Card, CircularProgress, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

interface IChartCardProps {
  title: React.ReactNode;
  //For the open full report button to the upper right
  report_id?: string;
  actionText?: string;
  hideButton?: boolean;
  actionButton?: React.ReactNode;
  isLoading?: boolean;
}

export const ChartCard = ({
  children,
  title,
  actionText = 'VIEW FULL REPORT',
  report_id,
  hideButton = false,
  actionButton,
  isLoading = false,
}: React.PropsWithChildren<IChartCardProps>) => {
  const action = actionButton ? (
    actionButton
  ) : (
    <Button
      variant='text'
      sx={{ visibility: hideButton ? 'hidden' : 'visible' }}
      component={Link}
      to={`/reporting/items/${report_id}`}
      target='_blank'
      disabled={isLoading}
    >
      {actionText}
    </Button>
  );

  return (
    <Card
      sx={{
        p: '1.5rem',
        width: '100%',
        minHeight: '350px',
        borderRadius: '0',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box
        sx={{ display: 'flex', justifyContent: 'space-between', pb: '1.5rem' }}
      >
        <Typography variant='subtitle1' sx={{ fontWeight: '500' }}>
          {title}
        </Typography>
        {action}
      </Box>
      {isLoading ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 2,
            flex: 1,
          }}
        >
          <CircularProgress size='48px' />
          <Typography variant='body2' color='text.secondary'>
            Loading...
          </Typography>
        </Box>
      ) : (
        children
      )}
    </Card>
  );
};
